<template>
  <div class="ggtf-modal-overlay" :class="{ show: show }" @click.self="show = false">
    <div class="ggtf-modal-content" @click.stop>
      <!-- 头部 -->
      <div class="ggtf-modal-header">
        <h3 class="ggtf-modal-title">
          <span class="title-icon">⚡</span>
          {{ $t('_ggtg._hzje') }}
        </h3>
        <button class="ggtf-close-btn" @click="closeModal">
          <CloseCircleOutlined style="font-size: 22px" />
        </button>
      </div>

      <!-- 主体 -->
      <div class="ggtf-modal-body">
        <!-- 封面图 -->
        <div class="ggtf-detail-cover">
          <img :src="current.img" :alt="current.title" class="ggtf-detail-image" />
          <div class="ggtf-badge" v-if="current.tag">{{ current.tag }}</div>
        </div>

        <!-- 信息区 -->
        <div class="ggtf-detail-info">
          <h4 class="ggtf-detail-title">{{ current.title }}</h4>
          <div class="ggtf-detail-code">
            <span class="code-label">{{ $t('_ggtf._hdbm') }}:</span>
            <span class="code-value">{{ current.code }}</span>
          </div>

          <div class="ggtf-detail-section">
            <h5 class="section-title">
              <span class="section-line"></span>
              {{ $t('_ggtf._hdjs') }}
            </h5>
            <p class="ggtf-detail-desc">{{ current.content || $t('_ggtf._zwjs') }}</p>
          </div>

          <!-- 金额信息 -->
          <div class="ggtf-detail-section">
            <h5 class="section-title">
              <span class="section-line"></span>
              {{ $t('_ggtg._dqye') }}
            </h5>
            <div class="ggtf-requirements">
              <div class="ggtf-requirement balance-item">
                <div class="requirement-left">
                  <img src="../../static/img/coins.png" class="coin-icon" />
                  <span class="balance-label">{{ $t('_ggtg._dqye') }}</span>
                </div>
                <div class="requirement-right">
                  <span class="balance-amount">${{ formatNumber(wallet.balance) }}</span>
                  <router-link :to="{ name: 'deposit' }" class="deposit-link">
                    {{ $t('_ggtg._qcz') }}
                    <span class="arrow">›</span>
                  </router-link>
                </div>
              </div>
              <div class="ggtf-requirement amount-item">
                <div class="requirement-left">
                  <span class="amount-label">{{ $t('_ggtg._hzje') }}</span>
                </div>
                <div class="requirement-right">
                  <span class="amount-value">${{ formatNumber(currentIncome?.store_income) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部按钮 -->
      <div class="ggtf-modal-footer">
        <button class="ggtf-cancel-btn" @click="closeModal">{{ $t('_ggtf._qx') }}</button>
        <button class="ggtf-confirm-btn" @click="onSubmit()" :disabled="loading">
          <span v-if="loading" class="spinner"></span>
          {{ loading ? $t('_ggtf._zfz') : $t('_ggtg._ljhz') }}
        </button>
      </div>
    </div>

    <!-- 密码输入框 -->
    <toast-password ref="pay" @sumbit="onPwdSubmit" :okText="$t('_ggtg._ljhz')"></toast-password>
  </div>
</template>

<script>
import { CloseCircleOutlined } from '@ant-design/icons-vue'
import ToastPassword from './ToastPassword.vue'

export default {
  name: 'AdvBuyVue',
  components: { ToastPassword, CloseCircleOutlined },
  data() {
    return {
      show: false,
      current: {},
      currentIncome: {},
      wallet: {},
      loading: false
    }
  },
  methods: {
    open(video, item) {
      this.show = true
      this.current = video
      this.currentIncome = item
      this.getWallet()
      document.body.style.overflow = 'hidden'
    },
    closeModal() {
      this.show = false
      document.body.style.overflow = ''
    },
    getWallet() {
      this.$api.userWallet.getWallet().then((res) => {
        this.wallet = res.data
      })
    },
    formatNumber(value) {
      if (value === undefined || value === null) return '0.00'
      return Number(value)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    // 立即购买
    onSubmit() {
      if (this.wallet.balance < this.currentIncome?.store_income) {
        this.$message.warning(this.$t('_ggtg._yebz'))
        return
      }
      this.$refs.pay.open()
    },
    onPwdSubmit(passwd) {
      this.loading = true
      this.$message.loading({ content: this.$t('_ggtf._zfz'), key: 'msg' })

      this.$api.videoAdv
        .payAdvIncome({
          code: this.currentIncome?.ua_24h_code,
          sort: this.currentIncome?.sort,
          passwd: passwd
        })
        .then((res) => {
          this.$message.warning({ content: res.msg, key: 'msg' })
          if (res.code == 1) {
            this.$message.warning({ content: res.msg, key: 'msg' })
            this.loading = false
            this.$refs.pay.resetLoading()
            return
          }
          this.$refs.pay.close()
          this.closeModal()
          this.$message.success({ content: res.msg, key: 'msg' })
          this.$emit('success')
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.$message.error({ content: this.$t('_ggtf._zfsb'), key: 'msg' })
        })
    }
  },
  beforeUnmount() {
    document.body.style.overflow = ''
  }
}
</script>

<style scoped>
/* ========== 遮罩层 ========== */
.ggtf-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.ggtf-modal-overlay.show {
  opacity: 1;
  visibility: visible;
}

/* ========== 内容卡片 ========== */
.ggtf-modal-content {
  background: #ffffff;
  border-radius: 20px;
  width: 92%;
  max-width: 480px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  transform: scale(0.9) translateY(20px);
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.ggtf-modal-overlay.show .ggtf-modal-content {
  transform: scale(1) translateY(0);
}

/* ========== 滚动条美化 ========== */
.ggtf-modal-content::-webkit-scrollbar {
  width: 4px;
}
.ggtf-modal-content::-webkit-scrollbar-track {
  background: transparent;
}
.ggtf-modal-content::-webkit-scrollbar-thumb {
  background: #d0d0d0;
  border-radius: 4px;
}

/* ========== 头部 ========== */
.ggtf-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px 14px;
  border-bottom: 1px solid #f0f0f0;
}

.ggtf-modal-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.title-icon {
  font-size: 20px;
}

.ggtf-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  padding: 4px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 36px;
  height: 36px;
}

.ggtf-close-btn:hover {
  color: #333;
  background: #f5f5f5;
}

/* ========== 主体 ========== */
.ggtf-modal-body {
  padding: 20px 24px 8px;
}

/* 封面图 */
.ggtf-detail-cover {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
  background: #f7f7f7;
  aspect-ratio: 16 / 9;
}

.ggtf-detail-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.ggtf-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  background: linear-gradient(135deg, #ff6b6b, #ee5a24);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 12px;
  border-radius: 20px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* 信息区 */
.ggtf-detail-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ggtf-detail-title {
  font-size: 17px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0;
  line-height: 1.4;
}

.ggtf-detail-code {
  font-size: 13px;
  color: #888;
  display: flex;
  align-items: center;
  gap: 4px;
}

.code-label {
  color: #aaa;
}

.code-value {
  color: #666;
  font-weight: 500;
}

/* 区块标题 */
.ggtf-detail-section {
  margin-top: 4px;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-line {
  display: inline-block;
  width: 3px;
  height: 14px;
  background: linear-gradient(180deg, #667eea, #764ba2);
  border-radius: 2px;
}

.ggtf-detail-desc {
  font-size: 14px;
  color: #555;
  line-height: 1.7;
  margin: 0;
  padding: 10px 14px;
  background: #f8f9fc;
  border-radius: 10px;
  word-break: break-word;
}

/* ========== 金额信息 ========== */
.ggtf-requirements {
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: #f8f9fc;
  border-radius: 12px;
  padding: 14px 16px;
}

.ggtf-requirement {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
}

.ggtf-requirement:not(:last-child) {
  border-bottom: 1px dashed #e8ecf1;
}

.requirement-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.requirement-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.coin-icon {
  width: 20px;
  height: 20px;
}

.balance-label {
  font-size: 14px;
  color: #666;
}

.balance-amount {
  font-size: 16px;
  font-weight: 700;
  color: #ff9800;
}

.deposit-link {
  font-size: 13px;
  color: #667eea;
  text-decoration: none;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 2px;
  transition: color 0.2s;
}

.deposit-link:hover {
  color: #5a6fd6;
}

.deposit-link .arrow {
  font-size: 18px;
  line-height: 1;
}

.amount-label {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.amount-value {
  font-size: 18px;
  font-weight: 700;
  color: #e74c3c;
}

/* ========== 底部按钮 ========== */
.ggtf-modal-footer {
  display: flex;
  gap: 12px;
  padding: 16px 24px 20px;
  border-top: 1px solid #f0f0f0;
}

.ggtf-cancel-btn,
.ggtf-confirm-btn {
  flex: 1;
  padding: 12px 0;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
}

.ggtf-cancel-btn {
  background: #f0f0f5;
  color: #666;
}

.ggtf-cancel-btn:hover {
  background: #e5e5ea;
  color: #333;
}

.ggtf-cancel-btn:active {
  transform: scale(0.97);
}

.ggtf-confirm-btn {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: #fff;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.ggtf-confirm-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.ggtf-confirm-btn:active:not(:disabled) {
  transform: scale(0.97);
}

.ggtf-confirm-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* 加载动画 */
.spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ========== 响应式 ========== */
@media (max-width: 420px) {
  .ggtf-modal-content {
    width: 96%;
    border-radius: 16px;
  }
  .ggtf-modal-header {
    padding: 14px 18px 10px;
  }
  .ggtf-modal-body {
    padding: 14px 18px 4px;
  }
  .ggtf-modal-footer {
    padding: 12px 18px 16px;
    flex-direction: column;
    gap: 8px;
  }
  .ggtf-modal-title {
    font-size: 16px;
  }
  .ggtf-requirements {
    padding: 12px 14px;
  }
  .balance-amount {
    font-size: 15px;
  }
  .amount-value {
    font-size: 16px;
  }
}
</style>
